export const ru = {
    no_issues: 'Тикетов пока нет',
};
